<template>
  <div style="display: contents">
    <DashboardPanelTemplate
      v-for="(section, index) of getStartedSections" :id="$t(getDivId(section))" :key="index"
      class="panel-template" :panel-size="panelSize" :panel-focus="panelFocus" :loading="loading"
    >
      <GetStartedSetupSectionPanel
        ref="section" :section-id="section.SectionId" :display-id="section.DisplayOrder"
        :section-title="$t(getTitle(section))" :active-section="isActiveSection(section)" :steps="section.Steps"
      />
      <hr
        class="vertical-rule" :style="verticalRuleCss(section)"
        :class="isSectionComplete(section) ? 'complete' : 'incomplete'"
      >
    </DashboardPanelTemplate>
  </div>
</template>
<script>
import DashboardPanelTemplate from '@/components/layouts/DashboardPanelTemplate'
import GetStartedSetupSectionPanel from './GetStartedSetupSectionPanel.vue'
import GetStartedSectionsEnum from '@/enums/modules/setup/getStartedSections'
import BaseRoutesEnum from '@/enums/modules/routes/base'
import { SetupGuideEnum } from '@/enums/modules/routes'

export default {
  name: 'GetStartedSetupPanelV2',
  components: {
    DashboardPanelTemplate,
    GetStartedSetupSectionPanel
  },
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      sectionOffsetHeights: undefined
    }
  },
  computed: {
    user () {
      return this.$shipBobStore.getters['user/getUser']
    },
    getStartedSections () {
      return this.$shipBobStore.getters['setupDashboard/getStartedSections']
    }
  },
  created () {
    this.$shipBobStore.dispatch('setupDashboard/getGetStartedSections')
  },
  mounted () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getDivId (section) {
      return 'Section' + section.SectionId + '.DivId'
    },
    getTitle (section) {
      return 'Section' + section.SectionId + '.Title'
    },
    firstUncompletedSection () {
      const section = this.getStartedSections.find(x => x.Steps.some(s => s.IsCompleted === false))
      if (section) {
        return section
      } else {
        // If all sections are completed then run the Handle onboarding complete
        this.handleOnboardingComplete()
        return 0
      }
    },
    isActiveSection (section) {
      const uncSection = this.firstUncompletedSection()
      if (!uncSection) {
        return section.DisplayOrder === 1
      }
      return uncSection.DisplayOrder >= section.DisplayOrder
    },
    dispatchStoreStepComplete (ItemId) {
      this.$shipBobStore.dispatch('setupDashboard/setGetStartedStep', { ItemId, IsCompleted: true })
    },
    handleOnboardingComplete () {
      const user = this.$shipBobStore.getters['user/getUser']
      this.$shipBobStore.dispatch('user/setUserStep', user.getStepEnum(SetupGuideEnum.OnboardingComplete)).then((response) => {
        this.$router.push({ name: BaseRoutesEnum.Dashboard })
      })
    },
    isSectionComplete (section) {
      return !section.Steps.some(step => step.IsCompleted === false)
    },
    getSectionElement (section, offset = 0) {
      const ref = this.$refs.section
      return ref ? ref[this.getStartedSections.indexOf(section) + offset] : undefined
    },
    getSectionHeight (section, offset = 0) {
      if (this.sectionOffsetHeights) {
        return this.sectionOffsetHeights[this.getStartedSections.indexOf(section) + offset]
      } else {
        const ele = this.getSectionElement(section, offset)
        return ele ? ele.$refs.sectionProgress.offsetTop : 0
      }
    },
    getSectionVisible (section, offset = 0) {
      const ele = this.getSectionElement(section, offset)
      return ele ? ele.isSectionVisible : false
    },
    handleResize () {
      const ref = this.$refs.section
      if (ref) {
        this.sectionOffsetHeights = ref.map(x => x.$refs.sectionProgress.offsetTop)
      }
    },
    verticalRuleCss (section) {
      const progressBarTop = this.getSectionHeight(section)
      const nextProgressBarTop = this.getSectionHeight(section, 1)
      const isSectionVisible = this.getSectionVisible(section)
      return {
        '--offset': progressBarTop + 'px',
        '--display': this.getSectionElement(section, 1) ? 'inherit' : 'none',
        '--height': isSectionVisible ? `calc(100% + ${nextProgressBarTop - progressBarTop + 4}px) ` : `calc(${progressBarTop + nextProgressBarTop}px + 2em)`
      }
    }
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'Welcome,',
        SubHeader: 'Let\'s get you set up. Follow these steps to get started:',
        ['Section' + GetStartedSectionsEnum.KYC]: {
          Title: 'Provide your business information'
        },
        ['Section' + GetStartedSectionsEnum.ConnectToShipBob]: {
          Title: 'Connect to ShipBob'
        },
        ['Section' + GetStartedSectionsEnum.ConfigureFulfillment]: {
          Title: 'Configure Your Fulfillment Settings'
        },
        ['Section' + GetStartedSectionsEnum.ImportOrders]: {
          Title: 'Import Your Orders and Start Shipping'
        }
      }
    }
  }
}

</script>
<style scoped lang='scss'>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_setup-panel-get-startedV2.scss';
</style>
